// Addresses of screens that take a parameter (kept free of imports so any
// component can use them).
export const timesheetPath = (id, view) => `/time/timesheets/${id}${view ? `/${view}` : ''}`;

export const jobPath = (jobNo, tab) =>
  `/jobs/${encodeURIComponent(String(jobNo || '').trim())}${tab ? `/${tab}` : ''}`;

// A screen with an optional ?job= (and other) deep-link parameters.
export const withQuery = (path, params) => {
  const q = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => { if (v != null && String(v).trim() !== '') q.set(k, String(v).trim()); });
  const s = q.toString();
  return s ? `${path}?${s}` : path;
};
